'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = 'M128 384l-32 0-64 0L0 384l0-32L0 32 0 0 32 0 352 0l32 0 0 32 0 320 0 32-32 0-64 0-32 0 0 32 0 64 0 32-32 0-64 0-32 0 0-32 0-64 0-32zm0-32l32 0 0 32 0 96 64 0 0-96 0-32 32 0 96 0 0-64L32 288l0 64 96 0zm224-96l0-224L224 32l0 80 0 16-32 0 0-16 0-80-64 0 0 112 0 16-32 0 0-16L96 32 32 32l0 224 320 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;